import $ from "jquery";
import React from "react";
import { i18n } from "react-i18n";
//import PropTypes from "prop-types";
import {
	Alert,
	Button,
	Glyph,
	Loader,
	Row,
	Col,
	Container,
	Card
} from "kepler";
import GiftAidDeclaration from "../components/charitydecl";
import { parseMessages } from '../../utilityHelper';

const templateData = $("body").data();

const charitySetupMsg = parseMessages("giftaid/charitysetup");
const charityDeclMsg = parseMessages("giftaid/charitydecl");

export default class GiftAidSetup extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			setupSuccess: false,
			giftAidEnabled: templateData.giftAid.giftAidEnabled,
			giftAidDisabled: templateData.giftAid.giftAidDisabled,
			giftAidUnEnrolled: templateData.giftAid.giftAidUnEnrolled,
			giftAidNotValidCharity: templateData.giftAid.notValidCharity,
			loader: false
		};
		this.showGiftAidSetupConfirmation = this.showGiftAidSetupConfirmation.bind(
			this
		);
		this.loadDeclarationPage = this.loadDeclarationPage.bind(this);
		this.loadGiftAidEnablePage = this.loadGiftAidEnablePage.bind(this);
	}

	showGiftAidSetupConfirmation() {
		let self = this,
			csrf = $("body").attr("data-csrf"),
			data = {
				preference: true,
				_csrf: csrf
			};
		self.setState({
			loader: true
		});
		$.post("/givingfund/giftaid/charitydecl", data, function(result) {
			if (result.giftAidStatus === "true") {
				self.setState({
					loader: false,
					setupSuccess: true
				});
			} else {
				self.setState({
					loader: false,
					setupSuccess: false
				});
				$(".errorMsg").show();
			}
		}).fail(function() {
			self.setState({
				loader: false
			});
			$(".errorMsg").show();
		});
	}

	loadDeclarationPage() {
		let self = this;
		self.setState({
			loader: false,
			giftAidEnabled: true,
			setupSuccess: true
		});
	}

	loadGiftAidEnablePage() {
		let self = this;
		self.setState({
			giftAidEnabled: false,
			giftAidDisabled: false,
			setupSuccess: false
		});
	}

	render() {
		let setupSuccess = this.state.setupSuccess,
			giftAidEnabled = this.state.giftAidEnabled,
			giftAidDisabled = this.state.giftAidDisabled,
			giftAidUnEnrolled = this.state.giftAidUnEnrolled,
			giftAidNotValidCharity = this.state.giftAidNotValidCharity;

		return (
			<div>
				{giftAidNotValidCharity ? (
					<Container
						id="giftAidCharityWapper"
						maxWidth={800}
						className="container"
					>
						<Row>
							<Card id="setupConfirmation" className="roundedBox">
								<div className="outerContainer">
									<div className="iconHolder">
										<Glyph
											icon="icon-attention-large"
											type="warning"
											size="large"
										/>
									</div>
									<h2>{charitySetupMsg.notValidCharity}</h2>
									<p>{charitySetupMsg.notValidCharityMsg}</p>
									<Button href="/charities/dashboard">
										{charitySetupMsg.confirmPPCC}
									</Button>
								</div>
							</Card>
						</Row>
					</Container>
				) : (
					<div>
						{/* GiftAid Enabled / Dsiabled */}
						{giftAidEnabled || giftAidDisabled ? (
							<GiftAidDeclaration
								content={charityDeclMsg}
								gaEnabled={giftAidEnabled}
								gaDisabled={giftAidDisabled}
								loadGiftAidEnablePage={
									this.loadGiftAidEnablePage
								}
							/>
						) : (
							<Container
								id="giftAidCharityWapper"
								maxWidth={800}
								className="container"
							>
								<Loader
									show={this.state.loader}
									priority={10}
									type="fixed"
									size="lg"
									opacity="0.5"
								/>
								<Alert type="error" className="errorMsg">
									<strong>{charitySetupMsg.postErr}</strong>
									{charitySetupMsg.postErrMsg}
								</Alert>
								{setupSuccess ? (
									<Row>
										<Card
											id="setupConfirmation"
											className="roundedBox"
										>
											<div className="outerContainer">
												<div className="iconHolder">
													<Glyph
														icon="icon-circled-checkmark-large"
														type="success"
														size="large"
													/>
												</div>
												<h2>
													{
														charitySetupMsg.setupSuccess
													}
												</h2>
												<p>
													{
														charitySetupMsg.setupSuccessMsg1
													}
												</p>
												<p>
													{
														charitySetupMsg.setupSuccessMsg2
													}
												</p>
												<Button
													id="successGA"
													onClick={
														this.loadDeclarationPage
													}
													className="btnLink"
												>
													{
														charitySetupMsg.setupSuccessDone
													}
												</Button>
											</div>
										</Card>
									</Row>
								) : (
									<div>
										<p className="title">
											{charitySetupMsg.setupConfirmTitle}
										</p>
										<Row>
											<Col sm="1/2">
												<Card className="dialogBg">
													<img
														src="https://www.paypalobjects.com/webstatic/ppgf/giftaid/MerchantWPSOption.png"
														alt="Merchant WPS Option"
													/>
													<h2>
														{
															charitySetupMsg.setupDonateBtn
														}
													</h2>
													<p>
														{
															charitySetupMsg.setupDonateMsg1
														}
													</p>
													<Button
														id="setupGA"
														onClick={
															this
																.showGiftAidSetupConfirmation
														}
													>
														{
															charitySetupMsg.setupEnable
														}
													</Button>
												</Card>
											</Col>
											<Col sm="1/2">
												<Card className="dialogBg">
													<img
														src="https://www.paypalobjects.com/webstatic/ppgf/giftaid/MerchantEcommerceOption.png"
														alt="Merchant e-Commerce Option"
													/>
													<h2>
														{
															charitySetupMsg.setupEcommTitle
														}
													</h2>
													<p>
														{
															charitySetupMsg.setupEcom1
														}
													</p>
													<p className="borderline">
														{
															charitySetupMsg.setupEcom2
														}
													</p>
													<Button
														type="link"
														href="/businessexp/tools"
													>
														{
															charitySetupMsg.returnToTools
														}
													</Button>
												</Card>
											</Col>
										</Row>
									</div>
								)}
							</Container>
						)}
					</div>
				)}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./giftaid/components/charitysetup.js